import { defineComponent, computed } from 'vue'
import HomeInfoPage from '@/modules/home/components/HomeInfoPage/HomeInfoPage.vue'
import TagElement from '@/components/ui/TagElement/TagElement.vue'
import { useMainPageStore } from '@/store/mainPage'
import { useScroll } from '@/composables/useScroll'
import { INFO_BLOCK_HEADINGS, INFO_BLOCK_ADD_BTN_TEXT_PART } from '@/constants/company'
import type { PropType } from 'vue'
import type {
  IBlockPage,
  IMainPageBlock,
  UpdateMainPageBlockProductPayload,
  UpdateMainPageBlockServicePayload,
  UpdateMainPagePromoPayload,
} from '@/types/mainPage'

export default defineComponent({
  name: 'HomeInfoBlock',
  components: {
    HomeInfoPage,
    TagElement,
  },
  props: {
    block: {
      type: Object as PropType<IMainPageBlock>,
      required: true,
    },
  },
  emits: ['editBlockClick', 'openPageForm', 'blockRemove', 'pageRemove'],
  setup(props, { emit }) {
    const isNews = computed(() => props.block.template === 'articles')
    const isVideo = computed(() => props.block.template === 'video')
    const mainPageStore = useMainPageStore()
    const scroll = useScroll()

    const templateRuNames = {
      articles: 'Новости',
      promo: 'Акции',
      products: 'Товарная выборка',
      services: 'Выборка по услугам',
      video: 'Видео',
    }

    const getTemplateText = computed(
      () => templateRuNames[props.block.template as keyof typeof templateRuNames] ?? '-',
    )

    const addBtnText = computed(
      () =>
        INFO_BLOCK_ADD_BTN_TEXT_PART[
          props.block.template as keyof typeof INFO_BLOCK_ADD_BTN_TEXT_PART
        ] ?? '',
    )

    const onPageEdit = (page: IBlockPage) => {
      const { template, title, id } = props.block

      let position
      if (template === 'promo') {
        position = scroll.scrollY.value
      }

      emit('openPageForm', template, id, title, page, position)
    }

    const onTogglePageIsActive = async (id: number, value: boolean) => {
      switch (props.block.template) {
        case 'products': {
          const updateProductPageBody: UpdateMainPageBlockProductPayload = {
            blockId: props.block.id,
            pageId: id,
            data: {
              isActive: value,
            },
          }
          await mainPageStore.updateBlockProduct(updateProductPageBody)
          break
        }

        case 'services': {
          const updateServicePageBody: UpdateMainPageBlockServicePayload = {
            blockId: props.block.id,
            pageId: id,
            data: {
              isActive: value,
            },
          }
          await mainPageStore.updateBlockService(updateServicePageBody)
          break
        }

        case 'promo': {
          const updatePromoPageBody: UpdateMainPagePromoPayload = {
            blockId: props.block.id,
            promoId: id,
            data: {
              is_active: value,
            },
          }
          await mainPageStore.updateBlockPromo(updatePromoPageBody)
          break
        }
        default:
          break
      }
    }

    const onDeletePageBtnClick = (id: number) => {
      const { template, id: blockId } = props.block
      emit('pageRemove', template, blockId, id)
    }

    return {
      INFO_BLOCK_HEADINGS,
      isNews,
      isVideo,
      getTemplateText,
      addBtnText,
      onPageEdit,
      onTogglePageIsActive,
      onDeletePageBtnClick,
    }
  },
})
